import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
export var WizardStep = function (_a) {
    var children = _a.children;
    return (_jsx(Box, { children: children }));
};
